<template>
    <search-select
        class="forum-search-select"
        :options="options"
        :value="value"
        :multiple="multiple"
        :placeholder="placeholder"
        :blurOnSelect="blurOnSelect"
        @input="$emit('input', $event)">
    </search-select>
</template>

<script>
    // ForumSearchSelect: stylizes the search select input for the forum.

    import SearchSelect from '../search-select';

    export default {
        // See src/components/reusable/search-select/index.vue for prop details.
        props: ['options', 'value', 'multiple', 'placeholder', 'blurOnSelect'],

        components: {
            SearchSelect,
        },
    }
</script>

<style lang="scss" scoped>
    .forum-search-select.search-select {
        margin-top: 5px;
        height: 34px; // 32px + border
        line-height: 32px;
        background: #1e1e1e;
        border: 1px solid #484848;
    }
</style>

<style lang="scss">
    .forum-search-select {
        .option:not(.highlighted) {
            background: #1e1e1e;
        }
    }
</style>



// WEBPACK FOOTER //
// search-select.vue?4f576388